import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { ReactComponent as SvgDotPatternIcon } from "../../images/dot-pattern.svg";
import { SectionHeading as HeadingTitle } from "../misc/Headings.js";

//images imported from local file system
import imageProfOne from "../../images/printpage/professional-prints-1.jpg";
import imageProfTwo from "../../images/printpage/professional-prints-2.jpg";
import imageProfThree from "../../images/printpage/professional-prints-3.jpg";

const Container = tw.div`relative`;

const SingleColumn = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;

const HeadingInfoContainer = tw.div`flex flex-col items-center`;
const HeadingDescription = tw.p`mt-4 font-medium text-gray-600 text-center max-w-sm`;

const Content = tw.div`mt-16`;

const Card = styled.div(props => [
  tw`mt-24 md:flex justify-center items-center`,
  props.reversed ? tw`flex-row-reverse` : "flex-row"
]);
const Image = styled.div(props => [
  `background-image: url("${props.imageSrc}");`,
  tw`rounded md:w-1/2 lg:w-5/12 xl:w-1/3 flex-shrink-0 h-80 md:h-144 bg-cover bg-center mx-4 sm:mx-8 md:mx-4 lg:mx-8`
]);
const Details = tw.div`mt-4 md:mt-0 md:max-w-md mx-4 sm:mx-8 md:mx-4 lg:mx-8`;
const Subtitle = tw.div`font-bold tracking-wide text-secondary-100`;
const Title = tw.h4`text-3xl font-bold text-gray-900`;
const Description = tw.p`mt-2 text-sm leading-loose`;
const Link = tw.a`inline-block mt-4 text-sm text-primary-500 font-bold cursor-pointer transition duration-300 border-b-2 border-transparent hover:border-primary-500`;

const List = tw.ul`mt-4 list-disc list-inside text-sm leading-loose text-gray-600`;

const SvgDotPattern1 = tw(
  SvgDotPatternIcon
)`absolute top-0 left-0 transform -translate-x-20 rotate-90 translate-y-8 -z-10 opacity-25 text-primary-500 fill-current w-24`;
const SvgDotPattern2 = tw(
  SvgDotPatternIcon
)`absolute top-0 right-0 transform translate-x-20 rotate-45 translate-y-24 -z-10 opacity-25 text-primary-500 fill-current w-24`;
const SvgDotPattern3 = tw(
  SvgDotPatternIcon
)`absolute bottom-0 left-0 transform -translate-x-20 rotate-45 -translate-y-8 -z-10 opacity-25 text-primary-500 fill-current w-24`;
const SvgDotPattern4 = tw(
  SvgDotPatternIcon
)`absolute bottom-0 right-0 transform translate-x-20 rotate-90 -translate-y-24 -z-10 opacity-25 text-primary-500 fill-current w-24`;

export default () => {
  const cards = [
    {
      imageSrc: imageProfOne,
      // subtitle: "Paid",
      title: "Choose from 3 sizes",
      list: {
        1: '8.5" x 11" (Letter)',
        2: '8.5" x 14" (Legal)',
        3: '11" x 17" (Tabloid)'
      },
      description:
        "Select the perfect size for your brochure to effectively showcase your content and design.",
      url: ""
    },

    {
      imageSrc:
        imageProfTwo,
      subtitle: "",
      title: "Paper for every occasion",
      list: {
        1: 'Standard and mid-weight white papers.',
        2: 'A variety of cardstock colors.',
        3: 'Premium paper varieties with gloss or matte finish.',
        4: 'Specialty paper types include recycled, transparent and more.'
      },
      description:
        "Print vibrant color and deep, rich black in the clearest detail with our top-quality paper.",
      url: ""
    },

    {
      imageSrc: imageProfThree,
      subtitle: "Exclusive",
      title: "Bind it all together",
      list: {
        1: 'Coil bind with spiral spine.',
        2: 'Comb bind with round plastic spine.',
        3: 'Cover bind with an adhesive spine.',
        4: 'Adjustable 3-ring binder.',
        5: 'Corner-stapled or side-stapled.'
      },
      description:
        "Whether you’re making a sales pitch or leading a training session, presentation is the key to success.",
      url: ""
    }
  ];

  return (
    <Container>
      <SingleColumn>
        {/* <HeadingInfoContainer>
          <HeadingTitle>Popular Events</HeadingTitle>
          <HeadingDescription>
            Here are some of the most popular events in New York City curated by professionals.
          </HeadingDescription>
        </HeadingInfoContainer> */}

        <Content>
          {cards.map((card, i) => (
            <Card key={i} reversed={i % 2 === 1}>
              <Image imageSrc={card.imageSrc} />
              <Details>
                <Subtitle>{card.subtitle}</Subtitle>
                <Title>{card.title}</Title>
                <Description>{card.description}</Description>
                {card.list && (
                  <List>
                    {Object.values(card.list).map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </List>
                )}
                {/* <Link href={card.url}>See Event Details</Link> */}
              </Details>
            </Card>
          ))}
        </Content>
      </SingleColumn>
      <SvgDotPattern1 />
      <SvgDotPattern2 />
      <SvgDotPattern3 />
      <SvgDotPattern4 />
    </Container>
  );
};
